import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "sonner";
const options = [
  { title: "Slider", value: "slider" },
  { title: "Game List", value: "game_list" },
  { title: "Tournament", value: "tournament" },
  { title: "CategoryWise", value: "category_wise" },
  { title: "Promotion", value: "promotion" },
  { title: "Custom HTML", value: "custom_html" },
];

const SectionTypesModal = ({ showModal, setShowModal, navigate }) => {
  const [selection, setSelection] = useState("");
  const handleProceed = () => {
    if (!selection) {
      toast.info("Please select a section type to proceed.", {
        duration: 2000,
      });
      return;
    }
    setShowModal(false);
    navigate(`/add-edit-section?sec_type=${selection}`);
  };
  return (
    <Modal
      show={showModal}
      onHide={() => {
        setSelection("");
        setShowModal(!showModal);
      }}
      size="lg"
      centered
      backdrop="static"
      className="text-light"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title>Select a section type </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <div className="row g-2 w-100 m-0">
          {options.map((item) => (
            <div
              className="col-sm-12 col-md-6 p-1"
              key={item.value}
              onClick={() => {
                setSelection(item.value);
              }}
            >
              <div
                className={`d-flex align-items-center justify-content-center p-2 rounded cursor-pointer w-100 ${
                  selection === item.value
                    ? "border-2 bg-slate-800"
                    : "border-gray-700 border-2 bg-dark"
                }`}
              >
                <span className="text-light text-lg font-bold text-center">
                  {item.title}
                </span>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light border-0">
        <Button
          variant="secondary"
          onClick={() => {
            setSelection("");
            setShowModal(false);
          }}
        >
          Cancel
        </Button>
        <Button
          variant="success"
          onClick={() => {
            handleProceed();
          }}
        >
          Proceed
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default SectionTypesModal;
